import request from './services/axios.js'

export default {
  //新建图书馆
  setBookLib: (params) => {
    return request({
      params,
      url: '/ebook/addLibrary',
      method: 'GET'
    })
  },
  //获取图书馆列表
  getBookLibList: (params) => {
    return request({
      params,
      url: '/ebook/getLibrarys',
      method: 'GET'
    })
  },
  //获取图书馆详情
  getMobileBookLibInfo: (params) => {
    return request({
      params,
      url: '/ebook/mobile/getLibraryById',
      method: 'GET'
    })
  },
  getBookLibInfo: (params) => {
    return request({
      params,
      url: '/ebook/getLibraryById',
      method: 'GET'
    })
  },
  // 编辑图书馆
  bookLibEdit: (params) => {
    return request({
      data: params,
      url: '/ebook/editLibrary',
      method: 'POST'
    })
  },
  // 图书馆微信分享
  bookLibWeChat: (params) => {
    return request({
      params,
      url: '/ebook/libraryWxShareParams',
      method: 'GET'
    })
  },
  // 图书馆已选书刊专辑列表
  bookLibAlready: (params) => {
    return request({
      params,
      url: '/ebook/getLibSelectedByPage',
      method: 'GET'
    })
  },
  // 图书馆可选书刊列表
  bookLibStayEb: (params) => {
    return request({
      params,
      url: '/ebook/getLibUnSelectedEbookByPage',
      method: 'GET'
    })
  },
  // 图书馆可选专辑列表
  bookLibStayAB: (params) => {
    return request({
      params,
      url: '/ebook/getUnSelectedAlbumByPage',
      method: 'GET'
    })
  },
  // 图书馆搜索
  searchInLibByKey: (params) => {
    return request({
      url: '/ebook/mobile/searchInLibByKey?id=' + params.id + '&key=' + params.key,
      method: 'GET'
    })
  },
  // 删除图书馆
  delLibrary: (id) => {
    return request({
      url: '/ebook/delLibrary?ids=' + id,
      method: 'GET'
    })
  }
}
